import Vue from 'vue';
import Router from 'vue-router';
import Layout_web from '@/layout_web/Layout';// PC端官网
import Layout_mobile from '@/layout_mobile/Layout';// 移动端官网

Vue.use(Router);

// 判断设备类型函数
function isMobileDevice() {
  // 判断是否为移动端
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// PC端
const pcRoutes = [
  {
    path:'/',//路径
    name:'PC',//命名
    component:Layout_web,//组件(布局组件)
    redirect:'/',//重定向
    children:[//子组件
      {// 首页
        path: "/",
        component: () => import("@/views/index")
      },
      {// 产品
        path: "products",
        component: () => import("@/views/products")
      },
      {// 解决方案
        path: "solution",
        component: () => import("@/views/solution")
      },
      {// 关于我们
        path: "about",
        component: () => import("@/views/about")
      },
      {// 服务支持
        path: "services",
        component: () => import("@/views/services")
      }
    ]
  },
];

// 移动端
const mobileRoutes = [
  {
    path:'/',//路径
    name:'Mobile',//命名
    component:Layout_mobile,//组件(布局组件)
    redirect:'/',//重定向
    children:[//子组件
      {// 首页
        path: "/",
        component: () => import("@/views/m_index")
      },
      {// 产品
        path: "products",
        component: () => import("@/views/m_products")
      },
      {// 解决方案
        path: "solution",
        component: () => import("@/views/m_solution")
      },
      {// 关于我们
        path: "about",
        component: () => import("@/views/m_about")
      },
      {// 服务支持
        path: "services",
        component: () => import("@/views/m_services")
      }
    ]
  }
];

// 根据设备类型选择要使用的路由配置
const selectedRoutes = isMobileDevice() ? mobileRoutes : pcRoutes;

export default new Router({
  routes: selectedRoutes
})
